module.exports = __webpack_public_path__ + "assets/92116c571ae85adb7db05f82a8991c2c.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/SecondTriggerPart2.mp3
 ** module id = 378
 ** module chunks = 0
 **/